import styles from './Divider.module.scss';

export const Divider: React.FC = () => {
  return <div className={styles.divider} />;
};
